var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7121 21.3031H4.46738C3.28256 21.3031 2.14626 20.8297 1.30847 19.9871C0.470665 19.1443 0 18.0013 0 16.8097V4.49345C0 3.30172 0.470665 2.15879 1.30847 1.3161C2.14626 0.473423 3.28256 0 4.46738 0H16.7121C17.8968 0 19.0332 0.473423 19.8709 1.3161C20.7088 2.15879 21.1794 3.30172 21.1794 4.49345V16.8097C21.1794 18.0013 20.7088 19.1443 19.8709 19.9871C19.0332 20.8297 17.8968 21.3031 16.7121 21.3031ZM4.46738 1.632C3.71288 1.632 2.98928 1.93348 2.45577 2.4701C1.92226 3.00673 1.62254 3.73455 1.62254 4.49345V16.8097C1.62254 17.5685 1.92226 18.2964 2.45577 18.833C2.98928 19.3696 3.71288 19.6711 4.46738 19.6711H16.7121C17.4665 19.6711 18.1902 19.3696 18.7237 18.833C19.2572 18.2964 19.5569 17.5685 19.5569 16.8097V4.49345C19.5569 3.73455 19.2572 3.00673 18.7237 2.4701C18.1902 1.93348 17.4665 1.632 16.7121 1.632H4.46738Z",
    fill: "#2BA828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7L9.125 14L6 10.8182",
    stroke: "#2BA828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.384892412f23d89c84be2309f3343b9b.svg";
export { ForwardRef as ReactComponent };